/**
 * ToggleBodyClass
 * ======================================
 * - toggle class on body
 * - multiple classes supported - "CLASSNAME CLASSNAME2 ..."
 * - add class to html attr [data-toggle="CLASSNAME"]
 * - remove class when attr [data-remove="CLASSNAME"]
 * - when [data-height="SELECTOR"] and [data-height-name="NAME"] are set,
 *   sets the CSS custom property --toggle-NAME-height on body to the
 *   height of the element matching SELECTOR
 */

 const ELEMENTS = '.js-ToggleBodyClass'

 class ToggleBodyClass {
   constructor() {
     this.elements = document.querySelectorAll(ELEMENTS)

     if (!this.elements) {
       return false
     }

     this.elements.forEach(el => {
       el.addEventListener('click', this.toggle, false)
     })
   }

   toggle = (e) => {
     const el = e.currentTarget
     const classes = el.getAttribute('data-toggle')
     const classesRemove = el.getAttribute('data-remove')

     if(classesRemove){
      classesRemove.split(" ").forEach(className => {
        document.body.classList.remove(className)
       })

      this.removeHeightProperty(el)
    } else {
     let added = false

     classes.split(" ").forEach(className => {
      added = document.body.classList.toggle(className)
     })

     if(added){
      this.setHeightProperty(el)
     } else {
      this.removeHeightProperty(el)
     }
    }

   }

   setHeightProperty = (el) => {
     const heightSelector = el.getAttribute('data-height')
     const heightName = el.getAttribute('data-height-name')

     console.log(heightSelector, heightName)

     if(heightSelector && heightName){
       const heightEl = document.querySelector(heightSelector)

       if(heightEl){
         const elHeight = heightEl.getBoundingClientRect().height
         document.body.style.setProperty(`--${heightName}-height`, `${elHeight}px`)
       }
     }
   }

   removeHeightProperty = (el) => {
     const heightName = el.getAttribute('data-height-name')

     if(heightName){
       document.body.style.removeProperty(`--${heightName}-height`)
     }
   }
 }

 new ToggleBodyClass()
